function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.1805 0.252121C19.0398 0.373606 14.7852 0.815793 12.1586 2.42361C11.9773 2.53454 11.8746 2.73181 11.8746 2.93806V17.1517C11.8746 17.6029 12.368 17.8881 12.784 17.6787C15.4863 16.3185 19.3945 15.9474 21.327 15.8459C21.9867 15.8111 22.4996 15.2822 22.4996 14.6482V1.45134C22.5 0.759543 21.9 0.211496 21.1805 0.252121ZM10.341 2.42361C7.71484 0.815793 3.46016 0.373996 1.31953 0.252121C0.6 0.211496 0 0.759543 0 1.45134V14.6486C0 15.283 0.512891 15.8119 1.17266 15.8463C3.10586 15.9478 7.01602 16.3193 9.71836 17.6802C10.1332 17.8892 10.625 17.6045 10.625 17.1545V2.93103C10.625 2.72439 10.5227 2.53493 10.341 2.42361Z",
  fill: "white"
});

var SvgMpProjects = function SvgMpProjects(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 23,
    height: 18,
    viewBox: "0 0 23 18",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMpProjects, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/MP_projects.14f809a4.svg";
export { ForwardRef as ReactComponent };